export default __webpack_public_path__ + "static/media/kayak.d94cfed8.jpg";